export class InputController {
  constructor() {
    this.state = {
      throttle: false,
      brake: false,
      left: false,
      right: false,
      handbrake: false,
      boost: false
    };

    this.onCameraToggle = null;
    this.onRespawn = null;

    this.setupKeyboard();
    this.setupTouch();
  }

  setupKeyboard() {
    window.addEventListener('keydown', (e) => {
      // Don't intercept browser keys with modifier combos
      if (e.altKey || e.ctrlKey || e.metaKey) return;

      switch (e.code) {
        case 'KeyW':
        case 'ArrowUp':
          this.state.throttle = true;
          e.preventDefault();
          break;
        case 'KeyS':
        case 'ArrowDown':
          this.state.brake = true;
          e.preventDefault();
          break;
        case 'KeyA':
        case 'ArrowLeft':
          this.state.left = true;
          e.preventDefault();
          break;
        case 'KeyD':
        case 'ArrowRight':
          this.state.right = true;
          e.preventDefault();
          break;
        case 'Space':
          this.state.handbrake = true;
          e.preventDefault();
          break;
        case 'ShiftLeft':
        case 'ShiftRight':
          this.state.boost = true;
          e.preventDefault();
          break;
        case 'KeyC':
          this.onCameraToggle?.();
          e.preventDefault();
          break;
        case 'KeyR':
          this.onRespawn?.();
          e.preventDefault();
          break;
      }
    });

    window.addEventListener('keyup', (e) => {
      switch (e.code) {
        case 'KeyW':
        case 'ArrowUp':
          this.state.throttle = false;
          break;
        case 'KeyS':
        case 'ArrowDown':
          this.state.brake = false;
          break;
        case 'KeyA':
        case 'ArrowLeft':
          this.state.left = false;
          break;
        case 'KeyD':
        case 'ArrowRight':
          this.state.right = false;
          break;
        case 'Space':
          this.state.handbrake = false;
          break;
        case 'ShiftLeft':
        case 'ShiftRight':
          this.state.boost = false;
          break;
      }
    });

    // Reset inputs when losing window focus
    window.addEventListener('blur', () => {
      for (const k in this.state) {
        this.state[k] = false;
      }
    });
  }

  setupTouch() {
    const isTouchDevice = 'ontouchstart' in window || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    if (isTouchDevice) {
      document.body.classList.add('touch-visible');
    }

    const buttons = document.querySelectorAll('.touch-btn');
    buttons.forEach((btn) => {
      const act = btn.getAttribute('data-act');
      if (!act) return;

      const setPressed = (pressed) => {
        if (pressed) {
          btn.classList.add('active');
          if (act === 'cam') this.onCameraToggle?.();
          else if (act === 'respawn') this.onRespawn?.();
          else if (act in this.state) this.state[act] = true;
        } else {
          btn.classList.remove('active');
          if (act in this.state) this.state[act] = false;
        }
      };

      btn.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        setPressed(true);
      });

      btn.addEventListener('pointerup', (e) => {
        e.preventDefault();
        setPressed(false);
      });

      btn.addEventListener('pointercancel', (e) => {
        e.preventDefault();
        setPressed(false);
      });

      btn.addEventListener('pointerleave', (e) => {
        setPressed(false);
      });
    });
  }
}
